import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLocation } from "@/lib/locations";
import { getLocalContent } from "@/lib/city-content";

export const FAQ = () => {
  const location = useLocation();
  const localContent = getLocalContent(location.name, location.regionSlug);
  
  const faqs = [
    {
      question: `How much does house cleaning cost in ${location.name}?`,
      answer: `Standard house cleaning in ${location.name} starts at $149. The exact price depends on your home's square footage and condition. Use our instant online pricing tool to get a flat-rate quote in seconds — no hidden fees or walkthroughs required.`
    },
    ...localContent.uniqueFaqs,
    {
      question: `Are there discounts for recurring cleaning in ${location.name}?`,
      answer: `Yes! We offer significant discounts for recurring maid service in ${location.name}: save 35% on weekly cleaning, 30% on biweekly cleaning, and 20% on monthly cleaning. Regular maintenance keeps your home consistently spotless.`
    },
    {
      question: `Do I need to be home during the cleaning service in ${location.name}?`,
      answer: `No, you do not need to be home. Most of our ${location.name} clients provide entry instructions (like a hidden key, garage code, or lockbox) when booking. Our trusted professionals will securely lock up when finished.`
    },
    {
      question: `Are your house cleaners in ${location.name} background checked and insured?`,
      answer: `Absolutely. Every cleaner we send to your ${location.name} home undergoes a rigorous background check, in-person interviews, and reference verification. We are fully licensed, bonded, and insured for your peace of mind.`
    },
    {
      question: "What is the difference between a standard clean and a deep clean?",
      answer: "A standard clean covers routine maintenance like dusting, vacuuming, mopping, and cleaning bathrooms and kitchens. A deep clean includes everything in a standard clean, plus detailed hand-wiping of baseboards, doors, blinds, and inside appliances. We highly recommend a deep clean for your first visit."
    },
    {
      question: `Do you offer a satisfaction guarantee for ${location.name} residents?`,
      answer: `Yes, we offer a 200% Ironclad Satisfaction Guarantee. If you are not completely satisfied with your cleaning in ${location.name}, let us know within 24 hours. We will return to reclean the missed areas for free. If you're still not happy, we offer a full refund.`
    }
  ];

  return (
    <section className="py-24 bg-muted/10">
      <div className="container max-w-4xl">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-16">Frequently Asked Questions</h2>
        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="bg-background px-6 rounded-xl border shadow-sm">
              <AccordionTrigger className="text-left font-bold py-6 hover:no-underline">
                <span className="flex gap-4">
                  <span className="text-primary">{i + 1}.</span>
                  {faq.question}
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed pb-6 pl-8">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        
        <div className="mt-16 text-center">
          <Button asChild variant="outline" size="lg" className="font-bold border-primary text-primary hover:bg-primary/10">
            <Link to={location.slug === 'sacramento-area' ? '/faq' : `/locations/${location.slug}/faq`}>View All Frequently Asked Questions</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};
